import { SxProps, Theme } from '@mui/material/styles';
import { AI_CURSOR } from './AIFindingValueViewer.styles';

export const getMergeBoxSx = (valuesDiffer: boolean, ctrlHeld = false): SxProps<Theme> => ({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  display: 'flex',
  alignItems: 'center',
  overflow: 'hidden',
  ...(valuesDiffer && { px: '10px' }),
  ...(ctrlHeld && {
    cursor: AI_CURSOR,
    '& *': { cursor: `${AI_CURSOR} !important` },
  }),
});

export const mergeTypographySx: SxProps<Theme> = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '2px',
  width: '100%',
  fontSize: 'inherit',
  lineHeight: 'inherit',
  minWidth: 0,
};

export const mergeCurrentValueSx: SxProps<Theme> = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  flexShrink: 1,
  minWidth: 0,
};

export const mergeArrowSx: SxProps<Theme> = { mx: '2px', flexShrink: 0 };

export const mergeAIValueSx: SxProps<Theme> = {
  fontWeight: 500,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  flexShrink: 1,
  minWidth: 0,
};
